module.exports = __webpack_public_path__ + "static/media/add-image-icon.c2ab1a6f.svg";